<template>
  <div class="footer">
    <div class="items">
      <div class="title" v-for="(value,index) in footers" @click="gotoLink(value.link)" :key="index">{{value.title}}
      </div>
    </div>

    <div class="center">
      <img src="../assets/icon-phone.png" />
      <span class="tip">服务热线 :</span>
      <span class="phone" @click="callPhone">400-1919-119</span>
    </div>
    <div class="bottom">©中消在线有限公司版权所有 | ICP备案编号：沪ICP备16039608号</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      footers: [
        // {'id': '1', 'title': '电脑版', 'link': 'http://www.zxzx119.com/'},
        { 'id': '2', 'title': '关于我们', 'link': '/aboutUs' },
        // { 'id': '3', 'title': '中消通', 'link': '/zx-tong' },
        { 'id': '3', 'title': '商家入驻', 'link': '/zx-tong' },
        { 'id': '4', 'title': '帮助中心', 'link': '/help' }
      ]
    }
  },
  watch: {
    $router () {
    }
  },
  methods: {
    gotoLink: function (link) {
      // if (link.indexOf('http') >= 0) {
      // window.location.href = link
      // } else {
      //   console.log(this.$route)
      this.$router.push({ path: link })
      // }
    },
    callPhone: function () {
      window.location.href = 'tel:4001919119'
    }
  }
}
</script>

<style scoped>
.footer {
  position: relative;
  height: 110px;
  background-color: #ffffff;
  border-top: #e0e0e0 solid 1px;
  box-sizing: border-box;
}
.footer .items {
  position: relative;
  top: 20px;
  left: 15px;
  width: calc(100% - 30px);
  height: 18px;
  line-height: 18px;
}
.footer .items .title {
  width: 33.3%;
  height: 18px;
  float: left;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-right: #e0e0e0 solid 1px;
  box-sizing: border-box;
}
.footer .items .title .link {
  color: #333333;
}
.footer .items .title:last-of-type {
  border-right: #ffffff solid 1px;
  box-sizing: border-box;
}
.footer .center {
  position: relative;
  top: 30px;
  left: 20px;
  width: calc(100% - 40px);
  height: 25px;
  line-height: 25px;
  background-color: #eeeeee;
  border-radius: 13px;
  text-align: center;
}
.footer .center img {
  position: relative;
  top: 3px;
  height: 13px;
  width: 13px;
}
.footer .center span {
  font-size: 12px;
  color: #808080;
}
.footer .center .tip {
  margin-left: 6px;
}
.footer .center .phone {
  font-size: 12px;
  color: #c41335;
}
.footer .bottom {
  position: relative;
  top: 35px;
  text-align: center;
  font-size: 11px;
  color: #808080;
}
</style>



// WEBPACK FOOTER //
// src/view/footer.vue